module.exports = __webpack_public_path__ + "img/photo2.79141a35.png";